// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentWithEmailSignaturePdfRequest {
    static getAttributeTypeMap() {
        return EnrollmentWithEmailSignaturePdfRequest.attributeTypeMap;
    }
}
EnrollmentWithEmailSignaturePdfRequest.discriminator = undefined;
EnrollmentWithEmailSignaturePdfRequest.additionalProperties = false;
EnrollmentWithEmailSignaturePdfRequest.attributeTypeMap = [
    {
        "name": "enrollmentRequest",
        "baseName": "enrollmentRequest",
        "type": "EnrollPatientRequestModel"
    },
    {
        "name": "emailSignaturePdfRequest",
        "baseName": "emailSignaturePdfRequest",
        "type": "EmailSignaturePdfRequest"
    },
];
//# sourceMappingURL=enrollmentWithEmailSignaturePdfRequest.js.map